import { NgModule } from '@angular/core'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'
import { StoreKeysEnum } from '../../../../store/store-keys'
import { generalMapReducer } from './state/general-map.reducer'
import { GeneralMapEffects } from './state/general-map.effects'

/**
 * General Map State Module
 *
 * This module registers NgRx store and effects for the General Map component.
 * It's imported globally in AppModule because GeneralMapModule is used across
 * multiple features (both eager and lazy-loaded):
 * - MapModule (eager)
 * - CaseViewModule, CaseEditModule (lazy - PurchaseCaseModule)
 * - BuildingsShowModule
 * - CommonDomainComponentsModule (used in 60+ modules)
 *
 * Registering NgRx state separately prevents double store/effects registration
 * when GeneralMapModule is imported in both eager and lazy-loaded modules.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(StoreKeysEnum.GeneralMapComponent, generalMapReducer),
        EffectsModule.forFeature([GeneralMapEffects]),
    ],
})
export class GeneralMapStateModule {}
